import React, { useEffect, useState } from 'react';
import { useAppState } from 'src/shared/appState'; // Import useAppState
import { loadScript } from 'src/shared/helpers';

interface LoadScriptsProps {
    scriptUrls: string[]; // Array of URLs to load
    children: React.ReactNode; // Content to render once all scripts are loaded
    fallback: React.ReactNode; // Content to show while scripts are loading
}

export const LoadScripts: React.FC<LoadScriptsProps> = ({ scriptUrls, children, fallback }) => {
    const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [scriptsLoaded, setScriptsLoaded] = useState(false);
    const { state, dispatch } = useAppState(); // Use the app state

    useEffect(() => {
        const loadAllScripts = async () => {
            const scriptsToLoad = scriptUrls.filter((url) => !state.loadedScripts.includes(url));

            for (let i = 0; i < scriptsToLoad.length; i++) {
                await loadScript(scriptsToLoad[i]);
                dispatch({ type: 'ADD_LOADED_SCRIPT', scriptUrl: scriptsToLoad[i] });
                setLoadingPercentage(((i + 1) / scriptsToLoad.length) * 100);
            }

            setScriptsLoaded(true);
        };

        if (scriptUrls.every((url) => state.loadedScripts.includes(url))) {
            setScriptsLoaded(true);
        } else {
            loadAllScripts();
        }
    }, [scriptUrls, dispatch]);

    if (!scriptsLoaded) {
        return fallback;
    }

    return <>{children}</>; // Render children when scripts are fully loaded
};
